import { Button, Flex, Select, Text } from "@chakra-ui/react";

import { useTasksNewData } from "../hooks/useTasksNewData";
import { useTasksNewFilters } from "../hooks/useTasksNewFilters";

const PAGE_SIZE_OPTIONS = [25, 50, 100];

export default function TasksNewPagination() {
  const filters = useTasksNewFilters();
  const { totalCount } = useTasksNewData();

  const page = filters.getValue("page") ?? 1;
  const pageSize = filters.getValue("pageSize") ?? 25;

  // Total pages is based on totalCount and pageSize (approximation — see useTasksNewData).
  const totalPages = Math.max(1, Math.ceil(totalCount / pageSize));

  function handlePrevPage() {
    if (page > 1) {
      filters.setValues({ page: page - 1 });
    }
  }

  function handleNextPage() {
    if (page < totalPages) {
      filters.setValues({ page: page + 1 });
    }
  }

  function handlePageSizeChange(e: React.ChangeEvent<HTMLSelectElement>) {
    const newSize = parseInt(e.target.value, 10);
    filters.setValues({ pageSize: newSize, page: 1 });
  }

  return (
    <Flex align="center" gap={3} mt={4} wrap="wrap">
      <Text color="gray.600" fontSize="sm">
        Total: {totalCount} tasks
      </Text>

      <Button isDisabled={page <= 1} size="sm" variant="outline" onClick={handlePrevPage}>
        Prev
      </Button>

      <Text fontSize="sm">
        Page {page} of {totalPages}
      </Text>

      <Button isDisabled={page >= totalPages} size="sm" variant="outline" onClick={handleNextPage}>
        Next
      </Button>

      <Select size="sm" value={pageSize} w="90px" onChange={handlePageSizeChange}>
        {PAGE_SIZE_OPTIONS.map((size) => (
          <option key={size} value={size}>
            {size} / page
          </option>
        ))}
      </Select>
    </Flex>
  );
}
